import { HiOutlineCube } from "react-icons/hi2";

import { cn } from "@/lib/cn";

export interface ProjectIconProps {
  className?: string;
}

export const ProjectIcon = ({ className }: ProjectIconProps) => {
  return <HiOutlineCube className={cn("h-4 w-4", className)} />;
};
